import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import { Link, Outlet } from 'react-router-dom'
import { Box, MenuItem, MenuList } from '@mui/material'
import Grid from '@mui/material/Grid'

const useStyles = createUseStyles({
  menuItem: {
    '&:hover': {
      backgroundColor: '#f1f1f1 !important',
      borderRadius: '2px !important',
    },
  },
})

function RoutedMenuItem({
  children, isActive, to, onClick,
}) {
  const classes = useStyles()
  return (
    <MenuItem
      component={Link}
      to={to}
      onClick={onClick}
      classes={{
        root: classes.menuItem,
      }}
      sx={{
        fontSize: '14px',
        fontFamily: isActive ? 'Roboto Medium, Helvetica, sans-serif' : 'Roboto Regular, Helvetica, sans-serif',
        fontWeight: isActive ? 500 : 400,
        textTransform: 'capitalize',
        lineHeight: '14px',
        borderRadius: isActive ? '0px' : 'inherit',
        borderLeft: isActive ? '2px solid #000' : 'inherit',
        backgroundColor: isActive ? '#f1f1f1' : 'inherit',
        color: '#2A2D36',
        padding: '16px 20px',
        marginBottom: '10px',
      }}
    >
      {children}

    </MenuItem>
  )
}

function RoutedMenu({ items, context, activeTab }) {
  const [tab, setTab] = useState(activeTab || items[0]?.to || '')

  return (
    <Grid container direction={{ xs: 'column', sm: 'row' }} wrap="nowrap" sx={{ minHeight: '200px' }}>
      <Grid item>
        <Box width="210px">
          <MenuList sx={{ paddingRight: '20px', paddingTop: '0px' }}>
            {items.map((item, i) => (
              <RoutedMenuItem
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                onClick={() => setTab(item.to)}
                isActive={tab === item.to}
                to={item.to}
              >
                {item.label}
              </RoutedMenuItem>
            ))}
          </MenuList>
        </Box>
      </Grid>
      <Grid item style={{ minWidth: 0, flex: 1, borderLeft: '1px solid #f1f1f1' }}>
        <Box
          maxWidth="1150px"
          sx={{
            paddingLeft: '40px',
            paddingBottom: '32px',
          }}
        >
          <Outlet context={context} />
        </Box>
      </Grid>
    </Grid>
  )
}

RoutedMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
  })).isRequired,
  context: PropTypes.shape({}),
  activeTab: PropTypes.string,
}

RoutedMenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool.isRequired,
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default RoutedMenu
